import priceFormatMixin from "@/mixins/priceFormat";

export default {
    install(Vue) {
        Vue.mixin(priceFormatMixin);
    },
};



// WEBPACK FOOTER //
// ./src/plugins/globalMixin.js